import { StringUtils } from '@teleporthq/teleport-shared';
export const insertLinks = (node, options, linkInParent = false, parentNode) => {
    var _a, _b, _c, _d, _e, _f;
    // TODO_NOW
    const { abilities, children, elementType, semanticType } = node.content;
    const linkInNode = linkInParent || !!((_a = abilities) === null || _a === void 0 ? void 0 : _a.link);
    // TODO: think of a way to reuse the traversal that modifies the tree
    node.content.children = (_b = children) === null || _b === void 0 ? void 0 : _b.map((child) => {
        var _a;
        if (child.type === 'element') {
            return insertLinks(child, options, linkInNode, node);
        }
        if (child.type === 'repeat') {
            child.content.node = insertLinks(child.content.node, options, linkInNode, node);
        }
        if (child.type === 'conditional' && child.content.node.type === 'element') {
            child.content.node = insertLinks(child.content.node, options, linkInNode, node);
        }
        if (child.type === 'slot' && ((_a = child.content.fallback) === null || _a === void 0 ? void 0 : _a.type) === 'element') {
            child.content.fallback = insertLinks(child.content.fallback, options, linkInNode, node);
        }
        return child;
    });
    if ((_c = abilities) === null || _c === void 0 ? void 0 : _c.link) {
        if (linkInParent) {
            console.warn('parent node has a link capability, nesting links is illegal');
            return node;
        }
        /* We repalce buttons with link to use <a> tag's, to make the generated
        code to be semantically correct. */
        if (elementType === 'button') {
            node.content.elementType = getLinkElementType(abilities.link);
            node.content.semanticType = '';
            node.content.attrs = createLinkAttributes(abilities.link, options);
            return node;
        }
        /* a text node (span) on which we added a link gets transformed into an <a>
         the rest of the text elements get wrapped with an <a> tag */
        if (elementType === 'text' && semanticType === 'span') {
            node.content.elementType = getLinkElementType(abilities.link);
            node.content.semanticType = '';
            node.content.attrs = createLinkAttributes(abilities.link, options);
            return node;
        }
        const linkNode = createLinkNode(abilities.link, options);
        linkNode.content.children.push(node);
        if (((_f = (_e = (_d = parentNode) === null || _d === void 0 ? void 0 : _d.content.style) === null || _e === void 0 ? void 0 : _e.display) === null || _f === void 0 ? void 0 : _f.content) === 'flex') {
            linkNode.content.style = {
                ...linkNode.content.style,
                display: { type: 'static', content: 'contents' },
            };
        }
        return linkNode;
    }
    return node;
};
export const createLinkNode = (link, options) => {
    return {
        type: 'element',
        content: {
            elementType: getLinkElementType(link),
            attrs: createLinkAttributes(link, options),
            children: [],
        },
    };
};
const getLinkElementType = (link) => {
    return link.type === 'navlink' ? 'navlink' : 'link';
};
const createLinkAttributes = (link, options) => {
    var _a;
    switch (link.type) {
        case 'url': {
            return {
                url: link.content.url,
                ...(link.content.newTab
                    ? {
                        target: {
                            type: 'static',
                            content: '_blank',
                        },
                        rel: {
                            type: 'static',
                            content: 'noreferrer noopener',
                        },
                    }
                    : {}),
            };
        }
        case 'section': {
            return {
                url: {
                    type: 'static',
                    content: `#${link.content.section}`,
                },
            };
        }
        case 'navlink': {
            return {
                transitionTo: {
                    type: 'static',
                    content: resolveNavlink(link.content.routeName, options),
                },
            };
        }
        case 'mail': {
            let mailUrl = `mailto:${link.content.mail}?subject=${_a = link.content.subject, (_a !== null && _a !== void 0 ? _a : '')}`;
            if (link.content.body) {
                mailUrl = mailUrl + `&body=${link.content.body}`;
            }
            return {
                url: { type: 'static', content: mailUrl },
            };
        }
        case 'phone': {
            return {
                url: { type: 'static', content: `tel:${link.content.phone}` },
            };
        }
        default:
            throw new Error(`createLinkNode called with invalid link type '${link.type}'`);
    }
};
const resolveNavlink = (routeName, options) => {
    var _a, _b, _c;
    if (options.skipNavlinkResolver) {
        return routeName;
    }
    if (routeName.startsWith('/')) {
        // attribute was explicitly set as a custom navlink
        return routeName;
    }
    const friendlyURL = StringUtils.camelCaseToDashCase(StringUtils.removeIllegalCharacters(routeName));
    const transitionRoute = options.projectRouteDefinition
        ? options.projectRouteDefinition.values.find((route) => route.value === routeName)
        : null;
    if (!transitionRoute) {
        return `/${friendlyURL}`;
    }
    return _c = (_b = (_a = transitionRoute) === null || _a === void 0 ? void 0 : _a.pageOptions) === null || _b === void 0 ? void 0 : _b.navLink, (_c !== null && _c !== void 0 ? _c : `/${friendlyURL}`);
};
//# sourceMappingURL=utils.js.map